import { DebugInfoOverlay } from "@/components/error-handling/DebugInfoOverlay";
import { StandardSyncErrorOverlay } from "@/components/error-handling/SyncErrorOverlay";
import { OnboardingOverlay } from "@/components/onboarding/OnboardingOverlay";
import { MessageOverlay } from "@/components/overlay/message-overlay/MessageOverlay";

export const AuthOverlay = () => {
  return (
    <>
      <OnboardingOverlay />
      <MessageOverlay />
      <StandardSyncErrorOverlay />
      <DebugInfoOverlay />
    </>
  );
};
